/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './template-medication.reducer';

export const TemplateMedicationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const templateMedicationEntity = useAppSelector(state => state.templateMedication.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="templateMedicationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.templateMedication.detail.title">TemplateMedication</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.templateMedication.id">Id</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.id}</dd>
          <dt>
            <span id="repetition">
              <Translate contentKey="tinyMedicRestApp.templateMedication.repetition">Repetition</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.repetition}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.templateMedication.active">Active</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.templateMedication.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.templateMedication.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.templateMedication.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.templateMedication.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.timestampEntry}</dd>
          <dt>
            <span id="prescribedCount">
              <Translate contentKey="tinyMedicRestApp.templateMedication.prescribedCount">Prescribed Count</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.prescribedCount}</dd>
          <dt>
            <span id="indication">
              <Translate contentKey="tinyMedicRestApp.templateMedication.indication">Indication</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.indication}</dd>
          <dt>
            <span id="daysFrequency">
              <Translate contentKey="tinyMedicRestApp.templateMedication.daysFrequency">Days Frequency</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.daysFrequency}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.templateMedication.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.endDate}</dd>
          <dt>
            <span id="dose">
              <Translate contentKey="tinyMedicRestApp.templateMedication.dose">Dose</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.dose}</dd>
          <dt>
            <span id="route">
              <Translate contentKey="tinyMedicRestApp.templateMedication.route">Route</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.route}</dd>
          <dt>
            <span id="templateItemType">
              <Translate contentKey="tinyMedicRestApp.templateMedication.templateItemType">Template Item Type</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.templateItemType}</dd>
          <dt>
            <span id="medicineName">
              <Translate contentKey="tinyMedicRestApp.templateMedication.medicineName">Medicine Name</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.medicineName}</dd>
          <dt>
            <span id="doseInstructions">
              <Translate contentKey="tinyMedicRestApp.templateMedication.doseInstructions">Dose Instructions</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.doseInstructions}</dd>
          <dt>
            <span id="tmType">
              <Translate contentKey="tinyMedicRestApp.templateMedication.tmType">Tm Type</Translate>
            </span>
          </dt>
          <dd>{templateMedicationEntity.tmType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateMedication.consumable">Consumable</Translate>
          </dt>
          <dd>{templateMedicationEntity.consumable ? templateMedicationEntity.consumable.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateMedication.implant">Implant</Translate>
          </dt>
          <dd>{templateMedicationEntity.implant ? templateMedicationEntity.implant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateMedication.prescription">Prescription</Translate>
          </dt>
          <dd>{templateMedicationEntity.prescription ? templateMedicationEntity.prescription.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/template-medication" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/template-medication/${templateMedicationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TemplateMedicationDetail;
